import { composeReducers } from "./presentation-reducer-utils"
import PresentationReducerBuilder from "./build-presentation-reducer"
import buildPlaceholdersPresentationReducer from "./build-placeholders-presentation-reducer"
import buildMappingsPresentationReducer from "./build-mappings-presentation-reducer"
import buildOwnerViewerPresentationReducer from "./build-owner-viewer-presentation-reducer"
import {
    KEY_ISSUE_ITEM_REQUEST as ITEM_REQUEST,
    KEY_ISSUE_ITEM_RESPONSE as ITEM_RESPONSE,
    DIMENSION_ITEM_SAVE_RESPONSE as ITEM_SAVE_RESPONSE,
    KEY_ISSUE_LIST_SEARCH_REQUEST as LIST_SEARCH_REQUEST,
    KEY_ISSUE_LIST_PAGE_REQUEST as LIST_PAGE_REQUEST,
    KEY_ISSUE_LIST_RESPONSE as LIST_RESPONSE,
    KEY_ISSUE_SET_FILTER as SET_FILTER,
    KEY_ISSUE_SET_EDIT_MODE as SET_EDIT_MODE,
    KEY_ISSUE_UPDATE_FILTER_CRITERIA as UPDATE_FILTER_CRITERIA,
    KEY_ISSUE_CLEAR_FILTER_CRITERIA as CLEAR_FILTER_CRITERIA,
    KEY_ISSUE_APPLY_FILTER_CRITERIA as APPLY_FILTER_CRITERIA,
    KEY_ISSUE_UPDATE_IMAGE as UPDATE_IMAGE,
    KEY_ISSUE_UPDATE_MODEL as UPDATE_MODEL,
    KEY_ISSUE_APPLY_MODEL_UPDATE as APPLY_MODEL_UPDATE,
    KEY_ISSUE_CANCEL_MODEL_UPDATE as CANCEL_MODEL_UPDATE,
    KEY_ISSUE_ADD_NEW as ADD_NEW,
    KEY_ISSUE_ADD_PLACEHOLDER_IMAGES as ADD_PLACEHOLDER_IMAGES,
    KEY_ISSUE_UPDATE_PLACEHOLDER_ATTRIBUTION as UPDATE_PLACEHOLDER_ATTRIBUTION,
    KEY_ISSUE_REMOVE_PLACEHOLDER as REMOVE_PLACEHOLDER,
    KEY_ISSUE_UPDATE_CONCEPTS as UPDATE_CONCEPTS,
    KEY_ISSUE_CLEAR_CONCEPTS as CLEAR_CONCEPTS,
    KEY_ISSUE_ADD_MAPPING as ADD_MAPPING,
    KEY_ISSUE_REMOVE_MAPPING as REMOVE_MAPPING,
    KEY_ISSUE_MAPPING_PREVIEW_REQUEST as MAPPING_PREVIEW_REQUEST,
    KEY_ISSUE_MAPPING_DELETE_PREVIEW_REQUEST as MAPPING_DELETE_PREVIEW_REQUEST,
    KEY_ISSUE_MAPPING_PREVIEW_RESPONSE as MAPPING_PREVIEW_RESPONSE,
    KEY_ISSUE_MAPPING_PREVIEW_ERROR_RESPONSE as MAPPING_PREVIEW_ERROR_RESPONSE,
    KEY_ISSUE_SELECT_PERMISSION_HOLDER_TYPE as SELECT_PERMISSION_HOLDER_TYPE,
    KEY_ISSUE_REMOVE_OWNER_VIEWER as REMOVE_OWNER_VIEWER,
    KEY_ISSUE_SEARCH_ADD_OWNERS_VIEWERS as SEARCH_ADD_OWNERS_VIEWERS,
    KEY_ISSUE_SEARCH_ADD_OWNERS_VIEWERS_RESPONSE as SEARCH_ADD_OWNERS_VIEWERS_RESPONSE,
    KEY_ISSUE_SELECT_ADD_OWNER_VIEWER as SELECT_ADD_OWNER_VIEWER,
    KEY_ISSUE_APPLY_ADD_OWNERS_VIEWERS as APPLY_ADD_OWNERS_VIEWERS,
    KEY_ISSUE_CANCEL_ADD_OWNERS_VIEWERS as CANCEL_ADD_OWNERS_VIEWERS,
} from "../../actions/action-types"
import {
    updateDimensionChangeModel,
    DimensionModel,
    updateDimensionCreateModel,
    DimensionCreateModel,
} from "../../models/entities/dimension"
import {
    KeyIssueFilterModel,
    updateKeyIssueSearchFilterModel,
} from "../../models/filters/key-issue-filter"
import { defaultSearchCriteria } from "../paging/dimension-paging-reducer"
import { serialiseSearchCriteria } from "../paging/paging-reducer-utils"

const reducerBuilder = new PresentationReducerBuilder()
const defaultReducer = reducerBuilder
    .actionsToHandle({
        UPDATE_IMAGE,
        UPDATE_MODEL,
        APPLY_MODEL_UPDATE,
        CANCEL_MODEL_UPDATE,
        CLEAR_FILTER_CRITERIA,
        UPDATE_FILTER_CRITERIA,
        APPLY_FILTER_CRITERIA,
        SET_FILTER,
        SET_EDIT_MODE,
        ITEM_REQUEST,
        ITEM_RESPONSE,
        ITEM_SAVE_RESPONSE,
        LIST_PAGE_REQUEST,
        LIST_SEARCH_REQUEST,
        LIST_RESPONSE,
        ADD_NEW,
    })
    .updateChangeModel(updateDimensionChangeModel)
    .updateCreateModel(updateDimensionCreateModel)
    .updateSearchFilterModel(updateKeyIssueSearchFilterModel)
    .workingFilterModelClass(KeyIssueFilterModel)
    .workingModelClass(DimensionModel)
    .canCancel(() => true)
    .createModelClass(DimensionCreateModel)
    .defaultState({
        workingModel: new DimensionModel(),
        searchCriteria: serialiseSearchCriteria(defaultSearchCriteria),
        workingFilterModel: new KeyIssueFilterModel(),
        searchFilterModel: defaultSearchCriteria,
        selectedPermissionHolder: "viewers",
        mappingToBeAdded: {
            positive: [],
        },
        mappingToBeDeleted: null,
        isFetchingPreview: false,
        isFetchingOwnersViewersSearch: false,
        isAddingOwnersViewers: false,
        ownersToAdd: [],
        viewersToAdd: [],
        ownersViewersSearchResponse: [],
        mappingPreview: null,
    })
    .build()
const placeholderReducer = buildPlaceholdersPresentationReducer(
    {
        ADD_PLACEHOLDER_IMAGES,
        UPDATE_PLACEHOLDER_ATTRIBUTION,
        REMOVE_PLACEHOLDER,
    },
    reducerBuilder._canSave
)
const mappingsReducer = buildMappingsPresentationReducer(
    {
        UPDATE_CONCEPTS,
        CLEAR_CONCEPTS,
        ADD_MAPPING,
        REMOVE_MAPPING,
        MAPPING_PREVIEW_REQUEST,
        MAPPING_DELETE_PREVIEW_REQUEST,
        MAPPING_PREVIEW_RESPONSE,
        MAPPING_PREVIEW_ERROR_RESPONSE,
    },
    updateDimensionChangeModel,
    updateDimensionCreateModel,
    reducerBuilder._canSave
)
const ownerViewerReducer = buildOwnerViewerPresentationReducer(
    {
        SELECT_PERMISSION_HOLDER_TYPE,
        SEARCH_ADD_OWNERS_VIEWERS,
        SEARCH_ADD_OWNERS_VIEWERS_RESPONSE,
        SELECT_ADD_OWNER_VIEWER,
        APPLY_ADD_OWNERS_VIEWERS,
        CANCEL_ADD_OWNERS_VIEWERS,
        REMOVE_OWNER_VIEWER,
    },
    updateDimensionChangeModel,
    updateDimensionCreateModel,
    reducerBuilder._canSave
)

export default (state = undefined, action) => {
    const defaultReduction = composeReducers(
        state,
        action,
        defaultReducer,
        placeholderReducer,
        mappingsReducer,
        ownerViewerReducer
    )
    const { type, name, value } = action
    switch (type) {
        case UPDATE_FILTER_CRITERIA:
        case LIST_SEARCH_REQUEST:
            let { searchFilterModel } = defaultReduction
            if (name === "empty" && value === false)
                searchFilterModel = searchFilterModel.remove("empty")
            return {
                ...defaultReduction,
                searchFilterModel,
            }
        default:
            return defaultReduction
    }
}
